import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserRoleEnum } from '@shared/enums';

import { AuthGuard } from '@auth0/auth0-angular';
import { ModalModeRedirectGuard, UserGuard } from '@core/guards';
import { ErrorPageComponent } from '@shared/components/error-page/error-page.component';
import { EmptyComponent } from '@shared/components/empty.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'schedule-pickup',
        pathMatch: 'full',
    },
    
    {
        // Path for legacy routes from other apps
        path: 'schedule-pickup-modal',
        canActivate: [ModalModeRedirectGuard],
        children: [
            {
              path: '**',
              component: EmptyComponent
            }
        ],
        data: {
            modalRedirectRoute: 'schedule-pickup'
        }
    },
    {
        path: 'schedule-pickup',
        canActivate: [AuthGuard, UserGuard],
        loadChildren: () => import('./features/schedule-pickup/schedule-pickup.module').then(m => m.SchedulePickupModule),
        data: {
            breadcrumb: null,
            roles: [UserRoleEnum.USER, UserRoleEnum.ADMIN],
        },
    },
    
    {
        // Path for legacy routes from other apps
        path: 'manage-pickups-modal',
        canActivate: [ModalModeRedirectGuard],
        children: [
            {
              path: '**',
              component: EmptyComponent
            }
        ],
        data: {
            modalRedirectRoute: 'manage-pickups'
        }
    },
    {
        path: 'manage-pickups',
        canActivate: [AuthGuard, UserGuard],
        loadChildren: () => import('./features/manage-pickups/manage-pickups.module').then(m => m.ManagePickupsModule),
        data: {
            breadcrumb: null,
            roles: [UserRoleEnum.ADMIN],
        },
    },
    {
        path: 'wellplate-overpack',
        canActivate: [AuthGuard, UserGuard],
        loadChildren: () => import('./features/wellplate-overpack/wellplate-overpack.module').then(m => m.WellplateOverpackModule),
        data: {
            breadcrumb: null,
            roles: [UserRoleEnum.WELLPLATE_OVERPACK, UserRoleEnum.ADMIN],
        },
    },
    {
        path: 'error',
        canActivate: [AuthGuard, UserGuard],
        component: ErrorPageComponent,
        data: {
            breadcrumb: null,
            roles: [UserRoleEnum.USER, UserRoleEnum.ADMIN],
        },
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
